@if (items().length) {
    <dl class="product-specifications-list" data-cy="product-specifications">
        @for (item of items(); track item.key) {
            <div class="product-specifications-pair" data-cy="product-specification">
                <dt class="product-specifications-label sir-text-style-paragraph-m-bold">
                    {{ item.label }}
                </dt>
                <dd class="product-specifications-value">
                    @if (item.primaryValueIsHtml) {
                        <sirius-text-html
                            class="product-specifications-rich-value"
                            [html]="item.primaryValue"
                            data-cy="product-specification-primary-value" />
                    } @else {
                        <span
                            class="product-specifications-primary-value"
                            data-cy="product-specification-primary-value">
                            {{ item.primaryValue }}
                        </span>
                    }
                    @if (item.secondaryValue; as secondaryValue) {
                        <span
                            class="product-specifications-secondary-value"
                            data-cy="product-specification-secondary-value">
                            ({{ secondaryValue }})
                        </span>
                    }
                </dd>
            </div>
        }
    </dl>
}
